import { useState } from "react";
//---------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { numberReducer, MyDate, Select, officeHolidays } from "src/components/common/functions";
import dayOffsTypes from "./dayOffsTypes";
//---------------------------------------------
export default function DayOffForm({
    keyword, handleSubmit, closeIt, usersList, requesterEmail,
    notes, formId, excelId, type, fromDate, toDate, data, 
    approverEmail, dayOffHashKey, submitTime
}){
    const curUser = useMyStore(state => state.user);
    const getDates = (startDate, stopDate) => {
        const dateArray = [];
        let currentDate = startDate;
        while(currentDate <= stopDate){
            const dateString = currentDate.s();
            const obj = {date: dateString, hours: "8", startTime: ""};
            if(currentDate.getDay() === 6 || currentDate.getDay() === 0){
                obj.hours = 0; 
                obj.weekend = true;
                obj.disabled = true;
            }
            const isHoliday = officeHolidays.find(h => h.date === dateString);
            if(isHoliday){
                obj.hours = 0; 
                obj.holiday = true;
                obj.holidayName = isHoliday.name;
                obj.disabled = true;
            }
            dateArray.push(obj);
            currentDate = new MyDate(currentDate.setDate(currentDate.getDate() + 1));
        }
        return dateArray;
    }
    //---------------------------------------------
    const defaultApprover = approverEmail?
    usersList.find(user => user.email === approverEmail)
    :{value:"", label:""};
    const defaultRequester = requesterEmail?
    usersList.find(user => user.email === requesterEmail)
    :usersList.find(user => user.email === curUser.email);
    const defaultDepartment = usersList.find(user => user.email === defaultRequester.value)?.department ?? "";
    //---------------------------------------------
    const [curRequester, setRequester] = useState(defaultRequester);
    const [curApprover, setApprover] = useState(defaultApprover);
    const [curType, setType] = useState(type || "");
    const [curFrom, setFrom] = useState(fromDate || "");
    const [curTo, setTo] = useState(toDate || "");
    const [curData, setData] = useState(data?JSON.parse(data):[]);
    const [curDepartment, setDepartment] = useState(defaultDepartment || "");
    //---------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"600px"}
            maxWidth = {"100%"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div className = "mt-2">
                {keyword === "Update"?<>
                <input
                    className = "nodisplay" readOnly
                    name = "formId" value = {formId}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "excelId" value = {excelId}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "dayOffHashKey" value = {dayOffHashKey}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "submitTime" value = {submitTime}
                />
                </>:<></>}
                <input
                    className = "nodisplay" readOnly
                    name = "action" value = {keyword}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "curData" value = {JSON.stringify(curData)}
                />
                <ul>
                    <li>
                        You must submit requests for absences, other than sick leave, two weeks prior to the first day you will be absent. 
                    </li>
                </ul>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3 mb-2 required-field">Request Date:</label>
                    <div className = "mb-2 mr-3" style = {{display: "flex", alignItems: "center"}}>
                        <label className = "mr-2">From</label>
                        <input
                            required
                            type = "date"
                            min = "1900-01-01"
                            max = {curTo || "2999-12-31"}
                            className = "form-control"
                            name = "fromDate"
                            value = {curFrom}
                            onChange = {e => {
                                setFrom(e.currentTarget.value);
                                if(curTo){
                                    setData(getDates(new MyDate(e.currentTarget.value.replace(/-/g,"/")), new MyDate(curTo.replace(/-/g,"/"))));
                                }
                            }}
                        />
                    </div>
                    <div className = "mb-2" style = {{display: "flex", alignItems: "center"}}>
                        <label className = "mr-2">To</label>
                        <input
                            required
                            type = "date"
                            min = {curFrom || "1900-01-01"}
                            max = "2999-12-31"
                            className = "form-control"
                            name = "toDate"
                            value = {curTo}
                            onChange = {e => {
                                const value = e.currentTarget.value;
                                setTo(value);
                                if(curFrom){
                                    setData(getDates(
                                        new MyDate(curFrom.replace(/-/g,"/")),
                                        new MyDate(value.replace(/-/g,"/"))
                                    ));
                                }
                            }}
                        />
                    </div>
                </div>
                {curFrom && curTo && usersList.find(user => curRequester?.value === user.email)?.outside === "no"?<>
                <span><strong>Detail Hours:</strong></span>
                <span className  = "ml-3">(2-hour increment)</span>
                <ul>
                    {curData.map((v, i) => <li key = {i} className = "my-3">
                        <span className = "mr-2">{v.date}</span>
                        {v.holiday || v.weekend?null:<>
                        <span className = "blk3">
                            {v.hours !== "8"?
                            <>
                            <span className = "mr-2">from</span>
                            <input
                                type = "time"
                                required className = "d-inline form-control mr-2"
                                value = {v.startTime}
                                onChange = {e => setData([
                                    ...curData.slice(0, i),
                                    {...v, startTime: e.currentTarget.value},
                                    ...curData.slice(i + 1)
                                ])}
                            />
                            </>:<></>}
                            <input
                                className = "d-inline form-control mr-2"
                                style = {{textAlign: "center"}}
                                required
                                disabled = {usersList.find(user => curRequester?.value === user.email)?.outside !== "no"}
                                type = "number"
                                step = {0.5}
                                max = {10}
                                min = {0}
                                value = {v.hours}
                                onChange = {e => setData([
                                        ...curData.slice(0, i), 
                                        {...v, hours: e.currentTarget.value}, 
                                        ...curData.slice(i + 1)
                                    ])
                                }
                            />
                            <span className = "mr-2">hours</span>
                        </span>
                        </>}
                        {v.holiday?<span className = "mr-2 text-info">({v.holidayName})</span>:null}
                        {v.weekend?<span className = "mr-2 text-success">(weekend)</span>:null}
                    </li>)}
                </ul>
                {curData.length?
                <div className = "font-weight-bold">
                    Total: <span style = {{color: "green"}}>{curData.map(v => window.Number.parseFloat(v.hours || 0)).reduce(numberReducer, 0)} hours</span>
                </div>
                :null}
                </>:null}
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3 required-field" style = {{whiteSpace: "nowrap"}}>Type of Absence Requested:</label>
                    <select
                        className = "form-control"
                        style = {{width: "auto!important"}}
                        required
                        name = "type"
                        value = {curType}
                        onChange = {e => setType(e.currentTarget.value)}
                    >
                        <option value = "">Select</option>
                        {dayOffsTypes.map((type, typei) => <option key = {typei}>{type}</option>)}
                        {curRequester?.projects !== "no"?<option>Time Off Without Pay</option>:null}
                    </select>
                </div>
                {curUser.projects !== "no"?<>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3 required-field">
                        Requester:
                    </label>
                    <div style = {{minWidth: 200, flexGrow: 1}}>
                        <Select 
                            isDisabled = {curUser.projects === "no"}
                            value = {curRequester}
                            onChange = {e => {
                                setRequester(e);
                                setDepartment(e?.department);
                            }}
                            options = {usersList}
                        />
                    </div>
                    {
                    usersList.find(user => curRequester?.value === user.email)?.outside &&
                    usersList.find(user => curRequester?.value === user.email)?.outside !== "no"?
                    <span className = "mx-3">
                        {usersList.find(user => curRequester?.value === user.email)?.outside}&nbsp;&nbsp;
                        {usersList.find(user => curRequester?.value === user.email)?.btlNumber}
                    <input
                        className = "nodisplay" readOnly
                        name = "btlNumber" value = {usersList.find(user => curRequester?.value === user.email)?.btlNumber}
                    />
                    </span>:null
                    }
                </div>
                </>:null}
                <input
                    className = "nodisplay" readOnly
                    name = "requesterEmail" value = {curRequester?.value}
                />
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3 required-field">Department:</label>
                    <input
                        style = {{flexGrow: 1}}
                        className = "form-control" readOnly
                        name = "department" value = {curDepartment}
                    />
                </div>
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label className = "font-weight-bold mr-3 required-field">Approver:</label>
                    <div style = {{minWidth: 200, flexGrow: 1}}>
                        <Select
                            value = {curApprover}
                            onChange = {e => {setApprover(e)}}
                            options = {usersList.filter(user => user.purchases === "approver")}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "approverEmail" value = {curApprover?.email || ""}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "approver" value = {curApprover?.label || ""}
                        />
                    </div>
                </div>
                <div className = "mb-2 font-weight-bold">
                    Notes:
                </div>
                <textarea
                    name = "notes"
                    defaultValue = {notes || ""}
                    className = "form-control mb-2"
                    style = {{width: "100%"}}
                />
            </div>
        </Modal>
    )
}